import { checkIsInternalUrl, getInternalUrlPath } from '@digital-spiders/misc-utils';
import React from 'react';
import { SITE_DOMAIN } from '../../constants';

export interface SmartLinkProps extends React.HTMLAttributes<HTMLElement> {
  to: string;
  children: React.ReactNode;
  className?: string;
  openInNewTab?: boolean;
}

export default React.forwardRef<any, SmartLinkProps>(function SmartLink(
  { openInNewTab, className, children, to, ...restProps },
  ref,
): React.ReactElement {
  if (to === '#') {
    return (
      <a
        className={className}
        ref={ref}
        href={to}
        tabIndex={-1}
        aria-disabled="true"
        style={{ pointerEvents: 'none' }}
        {...restProps}
      >
        {children}
      </a>
    );
  } else if (!openInNewTab && checkIsInternalUrl(to, SITE_DOMAIN)) {
    return (
      <a className={className} ref={ref} href={getInternalUrlPath(to, SITE_DOMAIN)} {...restProps}>
        {children}
      </a>
    );
  } else {
    return (
      <a
        className={className}
        ref={ref}
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        {...restProps}
      >
        {children}
      </a>
    );
  }
});
